export const BLUESHIFT_OTHERS_ALSO_BOUGHT_SLOT = 'BLUESHIFT_OTHERS_ALSO_BOUGHT_SLOT';
export const BLUESHIFT_POPULAR_IN_THE_SAME_CATEGORY_PRODUCTS_SLOT =
  'BLUESHIFT_POPULAR_IN_THE_SAME_CATEGORY_PRODUCTS_SLOT';
export const STUDIO_SEARCH_PAGE_SIZE = 30;

export const STUDIO_SEARCH_DEFAULT_SORT_BY = 'best_match';
export const STUDIO_SEARCH_MOST_POPULAR = 'most_popular';
export const STUDIO_SEARCH_MOST_NEWEST = 'newest';
export const STUDIO_SEARCH_RANDOM = 'random';

export const WALLPAPER_PAPER_TYPE_ATTRIBUTE_TYPE_NAME = 'UnifiedPaperType';
export const WALLPAPER_CUSTOM_SIZE_TYPE_NAME = 'WallpaperSize';
export const PRODUCT_TYPE_NAME = 'ProductType';
export const ORIENTATION_TYPE_NAME = 'Orientation';

export const DEFAULT_SCROLL_OFFSET = 150;

export enum ProductType {
  StudioSelectionPoster = 173,
  StudioSelectionCanvas = 174,
  StudioSelectionWallpaper = 176,
  Wallpaper = 177,
}

export const STUDIO_SELECTION_PRODUCT_TYPES = [
  ProductType.StudioSelectionPoster,
  ProductType.StudioSelectionCanvas,
  ProductType.StudioSelectionWallpaper,
];

export const WALLPAPER_PRODUCT_TYPES = [ProductType.Wallpaper, ProductType.StudioSelectionWallpaper];
export const RECENTLY_VIEWED_TYPES = [ProductType.StudioSelectionPoster, ProductType.StudioSelectionCanvas];

export enum MODE_SELECTOR {
  MODE_CANVAS_SELECTOR = 'Canvas selector',
  MODE_POSTER_SELECTOR = 'Poster selector',
  MODE_CANVAS_SELECTOR_PRICE_PER_FORMAT = 'Canvas selector (price per format)',
  MODE_POSTER_SELECTOR_PRICE_PER_FORMAT = 'Poster selector (price per format)',
}

export const MODE_SELECTOR_TYPES = [
  MODE_SELECTOR.MODE_CANVAS_SELECTOR,
  MODE_SELECTOR.MODE_POSTER_SELECTOR,
  MODE_SELECTOR.MODE_CANVAS_SELECTOR_PRICE_PER_FORMAT,
  MODE_SELECTOR.MODE_POSTER_SELECTOR_PRICE_PER_FORMAT,
];

const SELECTOR_UNIFIED_CANVAS_FORMAT = 'UnifiedCanvasFormat';
const SELECTOR_UNIFIED_PAPER_FORMAT = 'UnifiedPaperFormat';
const SELECTOR_ACRYLIC_FORMAT = 'AcrylicFormat';
const SELECTOR_CANVAS_FORMAT = 'CanvasFormat';
const SELECTOR_METALLIC_FORMAT = 'MetallicFormat';
const SELECTOR_PAPER_FORMAT = 'PaperFormat';

export const ALL_FORMAT_SELECTORS = [
  SELECTOR_UNIFIED_CANVAS_FORMAT,
  SELECTOR_UNIFIED_PAPER_FORMAT,
  SELECTOR_ACRYLIC_FORMAT,
  SELECTOR_CANVAS_FORMAT,
  SELECTOR_METALLIC_FORMAT,
  SELECTOR_PAPER_FORMAT,
];
